// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerBoxWidget":"bes_a bhp_tr","StrollerBoxWidget__imageCounselling":"bes_b bhp_kg"};